import React from 'react';

export default function NumberInput({
    value,
    label,
    ageRange,
    onIncrement = (f) => f,
    onDecrement = (f) => f,
    disabled,
}) {
    // console.log("number-input disabled", disabled);
    return (
        <div className="d-flex justify-content-between number-input-container border py-1 px-2 align-items-center">
            <a
                className={`decrement-button btn btn-primary border-right ${disabled &&
                    "disabled"} rounded-circle`}
                onClick={onDecrement}
            >
                <i className="fa fa-fw fa-minus text-white"></i>
            </a>
            <div>
                <p className="text-muted age-label mt-2 mx-2">
                    {label}
                    {ageRange && (
                        <span className="ml-1">
                            (<span>{ageRange.from}</span>
                            {ageRange.to > 0 ? (
                                <span>—{ageRange.to}</span>
                            ) : (
                                <span>+</span>
                            )}
                            <span className="ml-1">years</span>)
                        </span>
                    )}
                </p>
                <input
                    type="number"
                    value={value}
                    readOnly
                    className="number-input p-0 h-25"
                    disabled={disabled}
                />
            </div>

            <a
                className={`increment-button btn btn-primary border-left ${disabled &&
                    "disabled"} rounded-circle`}
                onClick={onIncrement}
            >
                <i className="fa fa-fw fa-plus text-white"></i>
            </a>
        </div>
    );
}   


// WEBPACK FOOTER //
// ./resources/js/components/NumberInput/index.js